import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, ListItem, Text,
} from '@domain-group/suit-theme'

import { buildFullDescription } from '@functions/orderItem'

import type { UseOrderPayload } from '@hooks/useOrder'
import { useRelations } from '@hooks/useOrderItem'

import { statusColors } from '@functions/status'

import type { OrderItemModel, UserModel } from '@models/types'

type CompactListOrderItemProps = {
  currentUser: UserModel,
  isCampaignManager: boolean,
  orderItem: OrderItemModel,
  url: string,
  useOrderPayload: UseOrderPayload,
}

const CompactListOrderItem = (props: CompactListOrderItemProps) => {
  const {
    currentUser,
    isCampaignManager,
    orderItem,
    url,
    useOrderPayload,
  } = props

  const {
    campaign,
    order: { priority_campaign_user_ids: priorityUserIds },
    publication,
    publicationEdition,
  } = useOrderPayload

  const isPriorityCampaignForCurrentUser = priorityUserIds?.includes(currentUser.id)

  const { status } = useRelations(orderItem)

  const { title } = orderItem

  // @ts-expect-error TS2739
  const itemTitle = buildFullDescription({ orderItem, publication, publicationEdition })

  return (
    // @ts-expect-error TS2339
    <ListItem.Compact
      contentRight={(
        <Box alignItems="center" flexDirection="row">
          {/*
           // @ts-expect-error TS2538 */}
          <Text color={statusColors[status.key]}>{status?.title}</Text>
        </Box>
    )}
      href={url}
    >
      {isPriorityCampaignForCurrentUser && !isCampaignManager && (
        <Text
          color="blue"
          display="inline-block"
          fontSize="small"
          marginRight="medium"
        >
          <FontAwesomeIcon icon={faStar} />
        </Text>
      )}

      {isCampaignManager ? `${itemTitle}` : `${campaign.title} - ${title}`}
      {/*
     // @ts-expect-error TS2339 */}
    </ListItem.Compact>
  )
}

export default CompactListOrderItem
